import { Line } from "vue-chartjs";

export default {
  extends: Line,
  name: "LineChart",
  // Hilfvariablen werden in dieser Komponente entgegengenommen
  props: ["dataChart", "options", "countGraph", "countGraph2"],
  mounted() {
    // generate color gradient
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, "rgba(204, 7, 30, 1)");
    this.gradient.addColorStop(0.5, "rgba(204, 7, 30, 0.9)");
    this.gradient.addColorStop(1, "rgba(204, 7, 30, 0.6)");
    this.dataChart.datasets[0].backgroundColor = this.gradient;
    this.renderTheChart();
  },
  // computed: {
  //   chartData() {
  //     return this.dataChart;
  //   }
  // },
  methods: {
    renderTheChart() {
      this.renderChart(this.dataChart, {
        responsive: true,
        maintainAspectRatio: false
      });
    }
  },
  // Watcher der bei Veränderung von countGraph auslöst
  watch: {
    countGraph: {
      handler: function() {
        // if(this.countGraph!=0){
        this.gradient = this.$refs.canvas
          .getContext("2d")
          .createLinearGradient(0, 0, 0, 450);
        var min = Math.ceil(0);
        var max = Math.floor(255);
        var math1 = Math.floor(Math.random() * (max - min)) + min;
        var math2 = Math.floor(Math.random() * (max - min)) + min;
        var math3 = Math.floor(Math.random() * (max - min)) + min;

        this.gradient.addColorStop(
          0,
          "rgba(" + math1 + ", " + math2 + ", " + math3 + ", 0.9)"
        );
        this.gradient.addColorStop(
          0.5,
          "rgba(" + math1 + ", " + math2 + ", " + math3 + ", 0.5)"
        );
        this.gradient.addColorStop(
          1,
          "rgba(" + math1 + ", " + math2 + ", " + math3 + ", 0.3)"
        );
        this.dataChart.datasets[0].backgroundColor = this.gradient;
        // }
        // Neuladen der Chart
        this.$data._chart.update();
      },
      deep: true
    },
    countGraph2: {
      handler: function() {
        // Neuladen der Chart
        this.$data._chart.update();
      },
      deep: true
    }
  }
};
